import { SCRAPING_PRODUCT, TARGET } from '@smartproxy/sp-utils';

import { Product } from '@/decodo/blocks/Scraper/constants/products';

import IconAmazon from './images/Amazon.svg';
import IconBing from './images/Bing.svg';
import IconGoogle from './images/Google.svg';
import IconInstagram from './images/Instagram.svg';
import IconReddit from './images/Reddit.svg';
import IconScraper from './images/Scraper.svg';
import IconTiktok from './images/Tiktok.svg';

export const targetLogosMap = {
  google: IconGoogle,
  bing: IconBing,
  amazon: IconAmazon,
  dc: IconScraper,
  instagram: IconInstagram,
  tiktok: IconTiktok,
  reddit: IconReddit,
} as const;

export type TargetLogo = keyof typeof targetLogosMap;

export type Target = {
  name: TARGET;
  label: string;
  logoKey: TargetLogo;
  product: Product;
};

const serpTargets: Target[] = [
  {
    name: TARGET.GOOGLE_SEARCH,
    label: 'Google search',
    logoKey: 'google',
    product: SCRAPING_PRODUCT.SERP,
  },
];

const universalTargets: Target[] = [
  {
    name: TARGET.UNIVERSAL,
    label: 'Web',
    logoKey: 'dc',
    product: SCRAPING_PRODUCT.UNIVERSAL,
  },
];

const ecommerceTargets: Target[] = [
  {
    name: TARGET.AMAZON_SEARCH,
    label: 'Amazon search',
    logoKey: 'amazon',
    product: SCRAPING_PRODUCT.ECOMMERCE,
  },
];

const socialMediaTargets: Target[] = [
  {
    name: TARGET.TIKTOK_POST,
    label: 'Tiktok Post',
    logoKey: 'tiktok',
    product: SCRAPING_PRODUCT.SOCIAL_MEDIA,
  },
];

export const targets: Target[] = [
  ...serpTargets,
  ...universalTargets,
  ...ecommerceTargets,
  ...socialMediaTargets,
];
